<template>
  <v-container text-xs-center fill-height>
    <v-layout row wrap justify-space-around align-center>
      <v-flex align-center align-content-center justify-center>
        <img src="@/assets/logo.png"/>
        <h1>The Best Omegle Alternative</h1>
        <p>Instant cam to cam chat with random strangers around the world</p>
        <br>
        <v-carousel hide-controls hide-delimiters class="elevation-0" style="max-width: 400px; height: 90px; display: inline-block">
          <v-carousel-item>
            <h2>⚡ Lightning Fast</h2>
            <p>Lightweight interface and ultra-fast backend.</p>
          </v-carousel-item>
          <v-carousel-item>
            <h2>💰 Completely Free</h2>
            <p>Free to use, for everyone, forever.</p>
          </v-carousel-item>
          <v-carousel-item>
            <h2>🕶️ Anonymous</h2>
            <p>No registration required.</p>
          </v-carousel-item>
          <v-carousel-item>
            <h2>🛡️ Secure</h2>
            <p>Encrypted connexion, we don't keep any log.</p>
          </v-carousel-item>
          <v-carousel-item>
            <h2>📱 Optimized for mobile</h2>
            <p>Progessive Web App that works on all your devices.</p>
          </v-carousel-item>
        </v-carousel>
        <h2>Click START and say Hi! 😄</h2>
        <v-btn large router to="/chat" v-on:click="next" color="success">Start</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions([
      'next'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue